import React, { Component } from "react";
import Navbar from "../../components/Navbar.js";
import { format_date, GET, loading, project, getCurrentProfile } from "../../components/CustomComponent.js";
import { stripJuristic } from "../../components/text-sanitize.js";
import { Modal } from "react-bootstrap";
import BANNER from "../../assets/images/banner.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
/* ============================================================================
 * Dashboard — หน้าแรกหลังล็อกอิน (ฝั่งงานหลัก)
 *
 * ★ หน้านี้ไม่ใช่หน้ารายงาน — มีหน้าที่แจ้งข่าวสาร/แบนเนอร์ที่ผู้ดูแลตั้งไว้
 *   ตัวเลขจริงอยู่ที่หน้ารายงานของแต่ละงาน
 * ========================================================================== */

export default class UploadData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
description: "",
createdAt: "",
      data_banner: [],
      data_news: [],

      // รูปแบนเนอร์ที่กดดูแบบเต็มภาพอยู่ ("" = ไม่ได้เปิด)
      image_preview: ""
    };
  }

  async componentDidMount() {
    this.Get();
    loading(false);
  }

   Get = async () => {
      loading(true);
      let data_banner, data_news;
      let [result_banner, result_news] = await Promise.all([
        GET("api/admin/banners/list",{page: 1}),
        GET("api/admin/news/list",{page: 1}),
      ]);
      if (result_banner.status) {
        data_banner = result_banner.data;
      }
      if (result_news.status) {
        data_news = result_news.data;
      }
      this.setState({data_banner, data_news})
    }

  render() {
    const { modal_detail, data_banner, data_news, description } = this.state;
    const profiles = getCurrentProfile();
    const today = format_date(new Date(), "dd/mm/yyyy");

    return (
      <div className="w-100 min-vh-100">
        <Navbar header="Transaction History" page1="หน้าหลัก" page2="ภาพรวม" />

        <div className="body px-3 pb-4 pt-0">
          {/* ---------------- หัวหน้า : ทักทาย + โครงการที่กำลังทำงานอยู่ ---------------- */}
          <div className="dash-hero rounded-4 p-4 mb-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <div className="dash-hero__eyebrow">{today}</div>
                <h3 className="fw-bold mb-1">สวัสดี {profiles?.full_name || profiles?.username || "ผู้ใช้งาน"}</h3>
                <div className="text-secondary">{stripJuristic(project?.project_name) || "ยังไม่ได้เลือกโครงการ"}</div>
              </div>
            </div>
          </div>

          <div className="row g-3">
            {/* ---------------- แบนเนอร์ ---------------- */}
            <div className="col-12 col-lg-8">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100" style={{ minHeight: "75vh" }}>
                <div id="mainCarousel" className="carousel slide h-100" data-bs-ride="carousel">
                  <div className="carousel-indicators">
                    {data_banner?.map((item, index) => (
                      <button
                        key={`indicator-${index}`}
                        type="button"
                        data-bs-target="#mainCarousel"
                        data-bs-slide-to={index}
                        className={index === 0 ? "active" : ""}
                        aria-label={`แบนเนอร์ที่ ${index + 1}`}
                      />
                    ))}
                    {!data_banner?.length && (
                      <button type="button" data-bs-target="#mainCarousel" data-bs-slide-to="0" className="active" aria-label="แบนเนอร์" />
                    )}
                  </div>

                  <div className="carousel-inner h-100 w-100">
                    {data_banner?.map((item, index) => (
                      <div className={`carousel-item h-100 w-100 ${index === 0 ? "active" : ""}`} key={`banner-${index}`}>
                        {/* ★ แบนเนอร์ถูกครอบให้พอดีกรอบ (cover) บางภาพจึงโดนตัดขอบ — กดที่ภาพเพื่อดูเต็ม */}
                        <div
                          className="dash-banner h-100 w-100 pointer"
                          title="กดเพื่อดูภาพเต็ม"
                          onClick={() => this.setState({ image_preview: item.image || BANNER })}
                        >
                          <span className="dash-banner__zoom icon">{"\uf00e"}</span>
                          <img
                          className="h-100 w-100" style={{objectFit: "cover"}}
                            src={item.image}
                            alt={`แบนเนอร์ที่ ${index + 1}`}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = BANNER;
                            }}
                          />
                        </div>
                      </div>
                    ))}
                    {!data_banner?.length && (
                      <div className="carousel-item h-100 w-100 active">
                        <div
                          className="dash-banner h-100 w-100 pointer"
                          title="กดเพื่อดูภาพเต็ม"
                          onClick={() => this.setState({ image_preview: BANNER })}
                        >
                          <span className="dash-banner__zoom icon">{"\uf00e"}</span>
                          <img className="h-100 w-100" style={{objectFit: "cover"}} src={BANNER} alt="แบนเนอร์" />
                        </div>
                      </div>
                    )}
                  </div>

                  {data_banner?.length > 1 && (
                    <>
                      <button className="carousel-control-prev" type="button" data-bs-target="#mainCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" />
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#mainCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" />
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* ---------------- ข่าวสาร ---------------- */}
            <div className="col-12 col-lg-4">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="d-flex align-items-center justify-content-between px-3 pt-3">
                  <h5 className="fw-bold mb-0">ข่าวสาร</h5>
                  <span className="badge rounded-pill bg-success-light text-success">{data_news?.length || 0}</span>
                </div>

                <div className="dash-news p-2">
                  {!data_news?.length ? (
                    <div className="text-center text-secondary py-5">
                      <div className="icon text-32 mb-2">{"\uf1ea"}</div>
                      ยังไม่มีข่าวสาร
                    </div>
                  ) : (
                    data_news.map((item, index) => (
                      <button
                        type="button"
                        key={`news-${index}`}
                        className="dash-news__item"
                        onClick={() => this.setState({ modal_detail: true, ...item })}
                      >
                        <div className="dash-news__text">{item.description}</div>
                        <small className="text-secondary text-10">
                          {item.createdAt ? format_date(item.createdAt, "dd/mm/yyyy hh:mm") : ""}
                        </small>
                      </button>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------- ดูแบนเนอร์แบบเต็มภาพ ----------------
            กดพื้นหลังหรือปุ่มกากบาทเพื่อปิด */}
        {!!this.state.image_preview && (
          <div className="dash-lightbox" onClick={() => this.setState({ image_preview: "" })}>
            <button type="button" className="dash-lightbox__close icon" title="ปิด">
              {"\uf00d"}
            </button>
            <img
              src={this.state.image_preview}
              alt="แบนเนอร์ขนาดเต็ม"
              onClick={(e) => e.stopPropagation()}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = BANNER;
              }}
            />
          </div>
        )}

        {/* VIEW */}
        <Modal show={modal_detail} size="lg" onHide={()=>{this.setState({modal_detail:false})}}>
          <Modal.Header>
            <h4 className="fw-bold mb-0">ข่าวสาร</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="text-wrap text-16">
              {description?.split("\n")?.map(e=>(
                <div style={{textIndent:30}}>{e}</div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex justify-content-center p-1">
              <button
                className="btn btn-outline-success px-5"
                onClick={() => {
                  this.setState({ modal_detail: false });
                }}
              >
                ปิดหน้าต่าง
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
